const doc = [({"en":({"js":({"upload_button":({"index":({"choose_files":"Choose files"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;